import { CnpjUtils } from '../../shared/utils/cnpj.utils';
import { Component, Inject, OnInit, ViewEncapsulation, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import * as moment from 'moment';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';
import { AppComponent } from '../../app.component';
import { AppConstantes } from '../../constants/app-constantes';
import { DadosCalculoDivida } from '../../shared/services/acordo-ressarcimento/api/models/dados-calculo-divida';
import { TipoCalculoDividaEnum } from '../../shared/services/acordo-ressarcimento/api/models/tipo-calculo-divida-enum';
import { Acordo, FormaPagamento, HonorarioFlutuante, Parcela, Devedor, ProcedenciaAcordo, TipoOrigemAcordo, TipoRecebimento, SumarizacaoAcordo, TipoPessoaEnum, CategoriaDevedor, TipoLinhaTelefonicaEnum, Endereco, Logradouro, RequestCancelamentoSAPType, RequestAlteracaoDataParcelaSAPType, DadosErroSAP, RequestCancelamentoPropostaType, RequestAprovacaoPropostaType, Dinamica, Pessoa, Congenere, RequestReprocessarBoletoType } from '../../shared/services/acordo-ressarcimento/api/models';
import { AcordoService, DominiosService, ParcelaService, PropostaService, GuiaPostalService, DevedoresService, SAPService, HistoricoService, BoletoService, CongenereService, EscritoriosService } from '../../shared/services/acordo-ressarcimento/api/services';
import { ConsultarPropostaService } from '../consultar-proposta.service';
import { count } from 'rxjs/operators';
import { LoadingService } from 'src/app/shared/services/components/loading.service';
import { PsModalLoadingComponent } from 'porto-seguro-guide';
import { SituacaoParcelaEnum } from 'src/app/constants/situacao-parcela.enum';
import { Observable, of } from 'rxjs';
import { formatDate } from '@angular/common';
import { ApiConfiguration } from 'src/app/shared/services/acordo-ressarcimento/api/api-configuration';
import { ArwDoReloadService } from 'src/app/core/arw-do-reload.service';


@Component({
  selector: 'app-detalhe-proposta',
  templateUrl: './detalhe-proposta.component.html',
  styleUrls: ['./detalhe-proposta.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class DetalhePropostaComponent implements OnInit {
  public formAcordo: FormGroup;
  public tiposRecebimento: TipoRecebimento[];
  public tiposOrigem: TipoOrigemAcordo[];
  public procedenciasAcordo: ProcedenciaAcordo[];
  public formasPagamento: FormaPagamento[];
  public acordo: Acordo = {};
  public devedor: Devedor = {};
  public parcelas: Parcela[] = [];
  private _submitted = false;
  public loading = false;
  public sumarizacaoAcordo: SumarizacaoAcordo[];
  public devedores: Devedor[] = [];
  private _submittedNovoDevedor = false;
  public listaCategoriaDevedor: CategoriaDevedor[];
  public codigoRamo = undefined;
  public indexEdicaoDevedor = undefined;
  public edicaoDevedor = false;
  public valorTipoPessoaRetorno: number;
  public logradouro: any;
  public sapCancelamento: RequestCancelamentoSAPType = {};
  public reprovacaoProposta: RequestCancelamentoPropostaType = {};
  public reprocessarBoletoBatch: RequestReprocessarBoletoType = {};
  public aprovacaoProposta: RequestAprovacaoPropostaType = {};
  public sapAtualizarParcela: RequestAlteracaoDataParcelaSAPType = {};
  public isSubmited = false;
  public selected: any;
  public tipoLinhaTelefonicaRetorno: any;
  public tipoPessoaRetorno: any;
  public numeroCepLogradouro: any;
  public numeroCepComplementoLogradouro: any;
  public idAcordo: number;
  public descricaoOrigemSistema: string;
  public indexAtualizacaoParcela: any;
  public flagHabilitarJustificativa: boolean[] = [];
  public situacaoDoAcordo = [];
  public valorSimulacao: any = null;
  public tipoPerfilUsuario: number;
  public flagHabilitarBotaoAprovacaoReprovacao;
  public valorVendaSalvadoGrid;
  public valorRecuperadoGrid;
  public valortotalHonorarioGrid;
  public flagBotaoGerarBoletoAtualizarParcela: boolean[] = [];
  public flagErroSAPColuna = false;
  public CodigoSAP: string[] = [];
  public justificativaEstorno: string = '';

  public flagBotaoCancelarProposta: boolean = true;
  public historicoErrosSAP: DadosErroSAP[];
  public possuiFormaPagamentoBoleto = false;
  public todosPagamentosCreditoConta = false;
  public existePagamento = false;
  public flagCancelaAcordo: boolean = JSON.parse(sessionStorage.getItem('flagCancelaAcordo'));
  public flagAprovaProposta: boolean = JSON.parse(sessionStorage.getItem('flagAprovaProposta'));
  public flagReprovaProposta: boolean = JSON.parse(sessionStorage.getItem('flagReprovaProposta'));
  public flagAtualizaParcela: boolean = JSON.parse(sessionStorage.getItem('flagAtualizaParcela'));
  public flagAlteraTerceiro: boolean = JSON.parse(sessionStorage.getItem('flagAlteraTerceiro'));
  public flagAjusteManual: boolean = JSON.parse(sessionStorage.getItem('flagAjusteManual'));
  public dataMinimaSelecao: String;
  public mask = createNumberMask({
    prefix: '',
    suffix: ' %',
    integerLimit: 3,
    includeThousandsSeparator: false,
  });
  checkboxComJuros: string;
  valorTotalPago: number = 0;
  public parcelaAtualizar: Parcela;
  public editarAcordo = false;
  public listaDinamicas: Dinamica[];
  public listaCongeneres: Pessoa[];
  public listaCongeneresFiltro: any[];
  public congenereSelecionado: any;
  public listaEscritoriosFiltro: any[];
  public nomeEscritorioFiltro: any[];
  public cadastroCongeneres: Congenere[];
  public dataEnvioAntares: any;
  constructor(private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    public acordoService: AcordoService,
    public dominiosService: DominiosService,
    public parcelaService: ParcelaService,
    public propostaService: PropostaService,
    public guiaPostalService: GuiaPostalService,
    public consultarPropostaService: ConsultarPropostaService,
    public devedoresService: DevedoresService,
    public sapService: SAPService,
    public historicoService: HistoricoService,
    public boletoService: BoletoService,
    public congenereService: CongenereService,
    public escritorioService: EscritoriosService,
    private arwDoReloadService: ArwDoReloadService,
    private loadingService: LoadingService,
    @Inject(AppComponent) public appComponent: AppComponent) {

  }

  ngOnInit() {
    if (this.arwDoReloadService.recarregarSeOrigemArwDoSemEnvConfig(
      ['/detalhe-proposta/'],
      'DetalhePropostaComponent.ngOnInit'
    )) {
      return;
    }

    this.codigoRamo = this.appComponent.codigoRamo;
  
    this.showLoading();

    this.idAcordo = this.route.snapshot.params['idAcordo'];
    console.log("Id acordo: " + this.idAcordo);


    this.tipoPerfilUsuario = 1; // esse valor irá retornar do serviço

    if (this.idAcordo && Number(this.idAcordo) > 0) {

      this.acordoService.obterAcordoPorCodigo(this.idAcordo).subscribe(result => {
        this.acordo = result;
        this.criarFormulario(this.acordo);

      //Inicio Projeto Recupera
      console.log('SESSIONSTORAGE:'+JSON.stringify(sessionStorage));
      if( sessionStorage.getItem('flagCancelaAcordo') && sessionStorage.getItem('flagCancelaAcordo') != "" ) {
        this.flagCancelaAcordo = JSON.parse(sessionStorage.getItem('flagCancelaAcordo'));
      }
      if( sessionStorage.getItem('flagAprovaProposta') && sessionStorage.getItem('flagAprovaProposta') != "" ) {
        this.flagAprovaProposta = JSON.parse(sessionStorage.getItem('flagAprovaProposta'));
      }
      if( sessionStorage.getItem('flagReprovaProposta') && sessionStorage.getItem('flagReprovaProposta') != "" ) {
        this.flagReprovaProposta = JSON.parse(sessionStorage.getItem('flagReprovaProposta'));
      }
      if( sessionStorage.getItem('flagAtualizaParcela') && sessionStorage.getItem('flagAtualizaParcela') != "" ) {
        this.flagAtualizaParcela = JSON.parse(sessionStorage.getItem('flagAtualizaParcela'));
      }
      if( sessionStorage.getItem('flagAlteraTerceiro') && sessionStorage.getItem('flagAlteraTerceiro') != "" ) {
        this.flagAlteraTerceiro = JSON.parse(sessionStorage.getItem('flagAlteraTerceiro'));
      }
      if( sessionStorage.getItem('flagAjusteManual') && sessionStorage.getItem('flagAjusteManual') != "" ) {
        this.flagAjusteManual = JSON.parse(sessionStorage.getItem('flagAjusteManual'));
      }
      //Fim Projeto Recupera

        console.log('DEVEDORES'+JSON.stringify(this.acordo.devedores));
        console.log('ACORDO'+JSON.stringify(this.acordo));
        //console.log('devedoresss'+this.acordo.devedores.length);
        //carregar as combobox
        this.carregarTiposRecebimento();
        this.carregarTiposOrigem();
        this.carregarProcedenciasAcordo();
        this.carregarFormasPagamento();
        this.carregarCategoriaDevedores();
        this.carregarHistoricoErrosSAP();
        this.carregarDinamicas();
        this.carregarCongeneres();
        this.carregarCadastroCongeneres();
        this.carregarAcordo(this.acordo);
        this.hideLoading();

        let dddTelefoneFixo;
        let numeroTelefoneFixo;
        let dddTelefoneCelular;
        let numeroTelefoneCelular;
        
        this.carregarDadosLinhaDotempo();

        for (let i = 0; i < this.acordo.devedores.length; i++) {

          for (let index = 0; index < this.acordo.devedores[i].telefones.length; index++) {

            if (this.acordo.devedores[i].telefones[index].tipoLinhaTelefonica == TipoLinhaTelefonicaEnum.FIXO) {
              dddTelefoneFixo = this.acordo.devedores[i].telefones[index].codigoDDDTelefone;
              numeroTelefoneFixo = this.acordo.devedores[i].telefones[index].numeroTelefone.toString();
              this.acordo.devedores[i].strTelefoneGrid = dddTelefoneFixo + numeroTelefoneFixo;
              this.acordo.devedores[i].strTelefoneGrid = this.acordo.devedores[i].strTelefoneGrid.replace(/^(\d\d)(\d)/g, "($1) $2");
              this.acordo.devedores[i].strTelefoneGrid = this.acordo.devedores[i].strTelefoneGrid.replace(/(\d{4})(\d)/, "$1-$2");

            } else if (this.acordo.devedores[i].telefones[index].tipoLinhaTelefonica == TipoLinhaTelefonicaEnum.CELULAR) {

              dddTelefoneCelular = this.acordo.devedores[i].telefones[index].codigoDDDTelefone;
              numeroTelefoneCelular = this.acordo.devedores[i].telefones[index].numeroTelefone.toString();
              this.acordo.devedores[i].strTelefoneGrid = dddTelefoneCelular + numeroTelefoneCelular;
              this.acordo.devedores[i].strTelefoneGrid = this.acordo.devedores[i].strTelefoneGrid.replace(/^(\d\d)(\d)/g, "($1) $2");
              this.acordo.devedores[i].strTelefoneGrid = this.acordo.devedores[i].strTelefoneGrid.replace(/(\d{5})(\d)/, "$1-$2");
            }
          }
        }

      }, error => {
        console.log('Erro ao visualizar detalhes da proposta!' + error);
        if (error.indexOf("Unauthorized") > 0) {
          this.appComponent.createAlert('Perfil não possui acesso a aplicação, favor verificar com administrador', 'error');
        } else {
          const theError: string = error.error.mensagens[2].mensagem;
          this.appComponent.createAlert(theError, 'error');
        }
        this.hideLoading();
      });
    } else {
      this.hideLoading();
    }
  }

  public habilitarJustificativa(index) {
    if (this.flagHabilitarJustificativa[index] == false) {
      this.flagHabilitarJustificativa[index] = true;
    } else {
      this.flagHabilitarJustificativa[index] = false;
    }
  }

  public formatarNumeroCepLogradouro(numeroCepLogradouro) {
    if (numeroCepLogradouro != null) {
      switch (numeroCepLogradouro.length) {
        case 5:
          numeroCepLogradouro = numeroCepLogradouro;
          this.numeroCepLogradouro = numeroCepLogradouro;
          break;
        case 4:
          numeroCepLogradouro = "0" + numeroCepLogradouro;
          this.numeroCepLogradouro = numeroCepLogradouro;
          break;
        case 3:
          numeroCepLogradouro = "00" + numeroCepLogradouro;
          this.numeroCepLogradouro = numeroCepLogradouro;
          break;
        case 2:
          numeroCepLogradouro = "000" + numeroCepLogradouro;
          this.numeroCepLogradouro = numeroCepLogradouro;
          break;
        case 1:
          numeroCepLogradouro = "0000" + numeroCepLogradouro;
          this.numeroCepLogradouro = numeroCepLogradouro;
          break;
        case 0:
          numeroCepLogradouro = "00000" + numeroCepLogradouro;
          this.numeroCepLogradouro = numeroCepLogradouro;
          break;
      }
    }
  }

  public formatarNumeroCepComplementoLogradouro(numeroCepComplementoLogradouro) {
    if (numeroCepComplementoLogradouro != null) {
      switch (numeroCepComplementoLogradouro.length) {
        case 3:
          numeroCepComplementoLogradouro = numeroCepComplementoLogradouro;
          this.numeroCepComplementoLogradouro = numeroCepComplementoLogradouro;
          break;
        case 2:
          numeroCepComplementoLogradouro = "0" + numeroCepComplementoLogradouro;
          this.numeroCepComplementoLogradouro = numeroCepComplementoLogradouro;
          break;
        case 1:
          numeroCepComplementoLogradouro = "00" + numeroCepComplementoLogradouro;
          this.numeroCepComplementoLogradouro = numeroCepComplementoLogradouro;
          break;
        case 0:
          numeroCepComplementoLogradouro = "000" + numeroCepComplementoLogradouro;
          this.numeroCepComplementoLogradouro = numeroCepComplementoLogradouro;
          break;
      }
    }
  }
  private carregarCategoriaDevedores(): void {
    this.dominiosService.obterListaCategoriaDevedor().subscribe(result => {
      this.listaCategoriaDevedor = result;
    });
  }

  private carregarHistoricoErrosSAP(): void {
    this.historicoService.obterHistoricoErrosSAP(this.acordo.codigoAcordo).subscribe(result => {
      this.historicoErrosSAP = result;
    });
  }

  private carregarDinamicas(): void {
    this.dominiosService.obterListaDinamicasJuridico().subscribe(result => {
      this.listaDinamicas = result;
    });
  }

  private carregarCongeneres(): void {
    this.listaCongeneresFiltro = [];
    const param = {
      codigoTipoPessoa: 2
    }
    this.congenereService.obterListaPessoas(param).subscribe(result => {
      this.listaCongeneres = result;
      if (this.devedor.congenere) {
        this.formAcordo.controls['congenere'].setValue(this.devedor.congenere.descricao);
      }
      for (let key in this.listaCongeneres) {
        this.listaCongeneresFiltro.push(this.listaCongeneres[key].nomeLegalPessoa);
      }
    });
  }

  public getSubmittedDevedor() {
    return this._submittedNovoDevedor;
  }

  public incluirTelefoneDevedor() {
    const control = <FormArray>this.formAcordo.controls['telefonesDevedor'];
    control.push(this.formBuilder.group({ tipoTelefone: '0', telefone: '' }));
  }

  public incluirEmailDevedor() {
    const control = <FormArray>this.formAcordo.controls['emailsDevedor'];
    control.push(this.formBuilder.group({ emailNovoDevedor: '' }));
  }

  public deleteRowTelefone(indexTelefone) {
    const control = <FormArray>this.formAcordo.controls['telefonesDevedor'];
    control.removeAt(indexTelefone);
  }

  public deleteRowEmail(indexEmail) {
    const control = <FormArray>this.formAcordo.controls['emailsDevedor'];
    control.removeAt(indexEmail);
  }

  private showLoading() {
    this.loading = true;
  }

  public onAbrirModal(evento) {
    console.log("Abrindo modal... ");
    this.valorSimulacao = null;
  }

  evento($event) {
    this.selected = $event;
    console.log($event);
  }

  public onFecharModal() {
    console.log("Fechando modal.. ");
    this.edicaoDevedor = false;
    this.indexEdicaoDevedor = undefined;
  }


  private hideLoading() {
    this.loading = false;
  }

  private carregarAcordo(acordo: Acordo) {
    this.formAcordo.controls['checkboxgAcordoEscalonado'].setValue(acordo.flagAcordoEscalonado === AppConstantes.FLAG_SIM);
    this.formAcordo.controls['aplicaCorrecao'].setValue(acordo.flagCobradaCorrecaoMonetaria === AppConstantes.FLAG_SIM);
    this.formAcordo.controls['dataDivida'].setValue(moment(acordo.dataDivida, "YYYY-MM-DD").format("DD/MM/YYYY"));
    this.formAcordo.controls['valorVendaSalvado'].setValue(acordo.valorSalvados);

    //valores a serem exibidos no grid
    this.valorVendaSalvadoGrid = this.formAcordo.value['valorVendaSalvado'];
    this.valorRecuperadoGrid = this.formAcordo.value['valorRecuperado'];
    this.valortotalHonorarioGrid = this.formAcordo.value['totalHonorario'];

    if (this.acordo.codigoOrigemSistema == AppConstantes.CODIGO_ORIGEM_SITEMA_JURIDICO) {
      this.descricaoOrigemSistema = "RESSARCIMENTO";
    } else if (this.acordo.codigoOrigemSistema == AppConstantes.CODIGO_ORIGEM_SITEMA_FIANCA) {
      this.descricaoOrigemSistema = "FIANÇA";
    }

    //INEX FABRICA - Base Historica ressarcimento - 2021 - INI
    /*
    if (this.acordo.codigoMarca == AppConstantes.CODIGO_RETORNO_MARCA_PORTO) {
      this.formAcordo.controls['codigoMarca'].setValue(AppConstantes.CODIGO_RETORNO_MARCA_PORTO);
    } else if (this.acordo.codigoMarca == AppConstantes.CODIGO_RETORNO_MARCA_ITAU) {
      this.formAcordo.controls['codigoMarca'].setValue(AppConstantes.CODIGO_RETORNO_MARCA_ITAU);
    }
    */
    if(this.acordo.processoRessarcimento.flagSinistroItau != null && this.acordo.processoRessarcimento.flagSinistroItau == 'S') {
    	this.formAcordo.controls['codigoMarca'].setValue(3);
    } else {
	    if (this.acordo.codigoMarca == AppConstantes.CODIGO_RETORNO_MARCA_PORTO) {
	      this.formAcordo.controls['codigoMarca'].setValue(AppConstantes.CODIGO_RETORNO_MARCA_PORTO);
	    } else if (this.acordo.codigoMarca == AppConstantes.CODIGO_RETORNO_MARCA_ITAU) {
	      this.formAcordo.controls['codigoMarca'].setValue(AppConstantes.CODIGO_RETORNO_MARCA_ITAU);
	    }
    }
    //INEX FABRICA - Base Historica ressarcimento - 2021 - FIM
    

    // Projeto Santos Mitsui 2024
    if (AppConstantes.TIPOS_MODALIDADES_MITSUI.includes(this.acordo.processoRessarcimento.codigoModalidade)) {
      this.formAcordo.controls['codigoMarca'].setValue(AppConstantes.CODIGO_RETORNO_MITSUI);
    }
    // Projeto R3 Azul 2024
    if (AppConstantes.TIPOS_MODALIDADES_AZUL.includes(this.acordo.processoRessarcimento.codigoModalidade)) {
      this.formAcordo.controls['codigoMarca'].setValue(AppConstantes.CODIGO_RETORNO_MARCA_AZUL);
    }
    
    let parcelasAcordo = this.acordo.parcelaLista.parcelas;
    this.formAcordo.controls['radioEntrada'].setValue("2");
    this.formAcordo.controls['qtdParcelas'].setValue(parcelasAcordo.length - 1);

    const parcelasFormArray = this.formAcordo.controls.parcelasForm as FormArray;
    parcelasFormArray.controls = [];

    //verifica se todas parcelas são credito em conta
    this.todosPagamentosCreditoConta = parcelasAcordo.filter(parcela => parcela.formaPagamento.codigoFormaPagamento == 3).length == parcelasAcordo.length;
    this.existePagamento = parcelasAcordo.filter(parcela => parcela.dataPagamentoParcela !== undefined).length == parcelasAcordo.length;

    for (let i = 0; i < parcelasAcordo.length; i++) {

      this.formAcordo.controls['dataBaixaParcela'].setValue(this.getDataFormatada(parcelasAcordo[i].dataBaixaParcela));
      this.formAcordo.controls['dataEnvioAntares'].setValue(parcelasAcordo[i].dataEnvioAntares);

      if (parcelasAcordo[i].tipoSituacaoParcelaAcordo.codigoTipoSituacaoParcelaAcordo == SituacaoParcelaEnum.PAGO) {
        this.valorTotalPago = this.valorTotalPago +
          parcelasAcordo[i].valorParcelaSemJuros +
          parcelasAcordo[i].valorParcelaJuros;
      }
      let dataPrimeiroVencimento = moment(parcelasAcordo[0].dataVencimentoParcela);
      let dataVencimentoMinimo = moment().add(2, 'days');
      let quantidadeDias = dataPrimeiroVencimento.diff(dataVencimentoMinimo, 'days');

      if (quantidadeDias >= 0) {
        this.flagHabilitarBotaoAprovacaoReprovacao = true;
      } else {
        this.flagHabilitarBotaoAprovacaoReprovacao = false;
      }

      if (parcelasAcordo[i].formaPagamento.codigoFormaPagamento == 1) {
        this.possuiFormaPagamentoBoleto = true;
      }

      let parcela = parcelasAcordo[i];
     
      if (parcela.codigoStatusSAP == 0){ 
        this.CodigoSAP[i] = "AGUARDANDO GRAVACAO DS";
      }
      if (parcela.codigoStatusSAP == 1){ 
        this.CodigoSAP[i] = "PENDENTE PROCESSAMENTO";
      }
      if (parcela.codigoStatusSAP == 2){ 
        this.CodigoSAP[i] = "EM PROCESSAMENTO SAP";
      }
      if (parcela.codigoStatusSAP == 3){ 
        this.CodigoSAP[i] = "PROCESSADO";
      }
      if (parcela.codigoStatusSAP == 4){
        this.CodigoSAP[i] = "COM ERRO";
      }
      if (parcela.codigoStatusSAP == 5){
        this.CodigoSAP[i] = "CANCELADO";
      }
      if (parcela.codigoStatusSAP == 6){
        this.CodigoSAP[i] = "ERRO PROCESSAMENTO SAP";
      }
      if (parcela.codigoStatusSAP == 7){
        this.CodigoSAP[i] = "CANCELADO REPROCESSADO";
      }
      
      // desabilita botão de gerar boleto && atualizar parcela caso a parcela esteja paga ou cancelada
      if (parcela.tipoSituacaoParcelaAcordo.codigoTipoSituacaoParcelaAcordo == 1 ||
        parcela.tipoSituacaoParcelaAcordo.codigoTipoSituacaoParcelaAcordo == 4 ||
        parcela.codigoStatusSAP != 3 || parcela.formaPagamento.codigoFormaPagamento == 3) {
        this.flagBotaoGerarBoletoAtualizarParcela[i] = false;
      }
      else {
        this.flagBotaoGerarBoletoAtualizarParcela[i] = true;
      }

      this.formAcordo.controls['checkboxComJuros'].setValue(parcela.flagCobrancaJuroAtraso === AppConstantes.FLAG_SIM);

      if (this.formAcordo.value['checkboxComJuros'] == true) {
        this.checkboxComJuros = "S";
      } else {
        this.checkboxComJuros = "N";
      }

      if (parcela.numeroParcela === 0) {
        this.formAcordo.controls['radioEntrada'].setValue("1");
        this.formAcordo.controls['valorEntrada'].setValue(parcela.valorParcela);
        this.formAcordo.controls['codigoFormaPagamentoEntrada'].setValue(parcela.formaPagamento.codigoFormaPagamento);
        this.formAcordo.controls['dataVencimentoEntrada'].setValue(this.getDataFormatada(parcela.dataVencimentoParcela));

        this.formAcordo.controls['codigoStatusSAP'].setValue(this.CodigoSAP[i]);
        this.formAcordo.controls['statusParcelaEntrada'].setValue(parcela.tipoSituacaoParcelaAcordo.nomeTipoSituacaoParcelaAcordo);
        this.formAcordo.controls['valorJurosEntrada'].setValue(this.getValorJurosParcela(parcela));
        this.formAcordo.controls['valorJuros'].setValue(this.getValorJurosParcela(parcela));
        this.formAcordo.controls['valorTotalEntrada'].setValue(this.getValorJurosParcela(parcela) + parcela.valorParcela);
        this.formAcordo.controls['valorHonorarioEntrada'].setValue(parcela.valorHonorarioPago);
        this.formAcordo.controls['dataPagamentoEntrada'].setValue(this.getDataFormatada(parcela.dataPagamentoParcela));
        this.formAcordo.controls['formaPagamentoEntrada'].setValue(parcela.formaPagamento.siglaFormaPagamento);
        this.formAcordo.controls['numeroTituloEntrada'].setValue(parcela.numeroTituloBoleto);
        this.formAcordo.controls['negativacaoEntrada'].setValue("Não"); //FIXE onde pegar???
        this.formAcordo.controls['dataPagamentoHonorarioEntrada'].setValue(this.getDataFormatada(parcela.dataPagamentoHonorario));

      } else {
        this.formAcordo.controls['codigoFormaPagamento'].setValue(parcela.formaPagamento.codigoFormaPagamento);
        this.formAcordo.controls['dataPrimeiroVencimento'].setValue(moment(parcela.dataVencimentoParcela, "YYYY-MM-DD").format("DD/MM/YYYY"));

        parcelasFormArray.push(this.formBuilder.group({
          numeroParcela: parcela.numeroParcela,
          valorParcela: parcela.valorParcelaSemJuros,
          valorParcelaOriginal: parcela.valorParcela,
          editada: false,
          dataVencimentoParcela: this.getDataFormatada(parcela.dataVencimentoParcela),
          valorHonorarioPago: parcela.valorHonorarioPago,
          statusParcela: parcela.tipoSituacaoParcelaAcordo.nomeTipoSituacaoParcelaAcordo,
          codigoStatusSAP: this.CodigoSAP[i],
          valorJuros: parcela.valorParcelaJuros,
          valorHonorario: parcela.valorHonorarioPago,
          dataPagamento: this.getDataFormatada(parcela.dataPagamentoParcela),
          formaPagamento: parcela.formaPagamento.siglaFormaPagamento,
          numeroTitulo: parcela.numeroTituloBoleto,
          negativacao: 'Não', //FIXE onde pegar???
          dataBaixaParcela: this.getDataFormatada(parcela.dataBaixaParcela),
          dataPagamentoHonorario: this.getDataFormatada(parcela.dataPagamentoHonorario),
          valorTotal: parcela.valorParcelaSemJuros + parcela.valorParcelaJuros,
          codigoParcela: parcela.codigoParcela,
          dataEnvioAntares: parcela.dataEnvioAntares,
        }));

        console.info("juros parcela: " + parcela.valorParcelaJuros);
      }
    }
    let devedores = this.acordo.devedores;
    console.log(JSON.stringify(this.acordo.devedores));

    if (this.acordo.devedores) {
      for (var i = 0; i < this.acordo.devedores.length; i++) {
        if ( devedores[i].flagCongenere) {
          this.devedor = devedores[i];
          console.log(JSON.stringify(this.devedor));
        }
      }
    }
    console.log("valor: " + this.valorTotalPago);
  }

  private criarFormulario(acordo: Acordo) {
    this.formAcordo = this.formBuilder.group({
      cnpjNovoDevedor: [],
      cpfNovoDevedor: [],
      codigoRamoOrigemAcordo: [acordo.processoRessarcimento.codigoRamoSinistro],
      codigoRamoSinistro: [acordo.processoRessarcimento.codigoRamoSinistro],
      numeroSinistro: [acordo.processoRessarcimento.numeroSinistro],
      anoSinistro: [acordo.processoRessarcimento.anoSinistro],
      sequenciaItemSinistro: [acordo.processoRessarcimento.sequenciaItemSinistro],
      codigoSucursal: [acordo.processoRessarcimento.codigoSucursal],
      //INEX FABRICA - Base Historica ressarcimento - 2021 - INI
      codigoSinistroItau: [acordo.processoRessarcimento.codigoSinistroItau],
      //INEX FABRICA - Base Historica ressarcimento - 2021 - FIM
      escritorio: [acordo.nomeEscritorio],
      codigoTipoRecebimento: [acordo.tipoRecebimento.codigoTipoRecebimento],
      codigoProcedencia: [acordo.procedencia.codigoProcedencia],
      codigoTipoOrigem: [acordo.tipoOrigemAcordo.codigoTipoOrigem],
      flagAcordoEscalonado: [acordo.flagAcordoEscalonado],
      dataDivida: [acordo.dataDivida],
      valorAtualDivida: [acordo.valorAtualDivida],
      valorAcordo: [acordo.valorAcordo],
      valorRecuperado: [acordo.valorRecuperado],
      valorAtualizado: [null],
      valorAtualizadoSave: Number,
      valorDesconto: [acordo.valorDesconto],
      valorDiferencaDivida: [acordo.valorDiferencaDivida],
      valorDiferencaComHonorario: [null],
      valorDiferencaComHonorarioSave: [null],
      valorAtualizadoComHonorario: [null],
      valorAtualizadoComHonorarioSave: [null],
      percentualHonorarioFlutuante: [acordo.percentualHonorarioFlutuante],
      percentualHonorario: [acordo.percentualHonorario],
      percentualDesconto: [acordo.percentualDesconto],
      percentualTaxaJuro: [acordo.percentualTaxaJuro],
      percentualTaxaJuroParcela: [acordo.percentualTaxaJuroParcela],
      qtdParcelas: [null, Validators.compose([Validators.required])],
      dataVencimentoEntrada: [null],
      dataPrimeiroVencimento: [null],
      valorEntrada: [null],
      valorHonorarioEntrada: [null],
      valorVendaSalvado: [acordo.valorSalvados],
      codigoFormaPagamentoEntrada: [null],
      codigoStatusSAP: [null],
      statusParcelaEntrada: [null],
      valorJurosEntrada: [null],
      valorTotalEntrada: [null],
      dataPagamentoEntrada: [null],
      formaPagamentoEntrada: [null],
      numeroTituloEntrada: [null],
      negativacaoEntrada: [null],
      dataPagamentoHonorarioEntrada: [null],
      checkboxComJuros: [null],
      valorSimulacao: [null],
      checkboxgAcordoEscalonado: [null],
      aplicaCorrecao: [null],
      codigoFormaPagamento: [null],
      radioEntrada: [null],
      parcelasForm: this.formBuilder.array([]),
      nomeCongenere: [''],
      totalAcordo: [acordo.sumarizacaoAcordo.totalAcordo],
      totalJuros: [acordo.sumarizacaoAcordo.totalJuros],
      totalHonorario: [acordo.sumarizacaoAcordo.totalHonorario],
      totalSemJuros: [acordo.sumarizacaoAcordo.totalSemJuros],
      totalComJuros: [acordo.sumarizacaoAcordo.totalComJuros],
      nomeNovoDevedor: [''],
      scoreDevedor: Number,
      telNovoDevedor: [''],
      emailNovoDevedor: [''],
      negativadoNovoDevedor: [''],
      congenereNovoDevedor: [''],
      codigoEndereco: Number,
      cepNovoDevedor: [''],
      tipoEnderecoNovoDevedor: [''],
      enderecoNovoDevedor: [''],
      numeroNovoDevedor: [''],
      complementoNovoDevedor: [''],
      bairroNovoDevedor: [''],
      cidadeNovoDevedor: [''],
      estadoNovoDevedor: [''],
      codigoCategoriaDevedor: [null],
      flagPagador: [null],
      nomeCategoriaDevedor: [''],
      tipoPessoa: [''],
      telefonesDevedor: this.formBuilder.array([]),
      emailsDevedor: this.formBuilder.array([]),
      sistemaOrigem: Number,
      codigoAcordo: Number,
      textoJustificativaCancelamento: ['', Validators.required],
      textoJustificativaAprovacao: ['', Validators.required],
      textoJustificativaEstorno: ['', Validators.required],
      novaDataVencimento: '',
      enderecoEmail2Via: [''],
      codigoParcela2Via: Number,
      codigoMarca: [''],
      dataBaixaParcela: [''],
      dinamica: [acordo.descricaoDinamica],
      congenere: [''],
      codigoEscritorio: [''],
      dataEnvioAntares: [''],
    });
  }

  private carregarTiposRecebimento(): void {
    this.dominiosService.obterTiposRecebimento().subscribe(result => {
      this.tiposRecebimento = result;
    });
  }

  private carregarTiposOrigem(): void {
    this.dominiosService.obterTiposOrigemAcordo().subscribe(result => {
      this.tiposOrigem = result;
    });
  }

  private carregarProcedenciasAcordo(): void {
    this.dominiosService.obterProcedenciasAcordo().subscribe(result => {
      this.procedenciasAcordo = result;
    });
  }

  private carregarFormasPagamento(): void {
    this.dominiosService.obterFormasPagamento().subscribe(result => {
      this.formasPagamento = result;
    });
  }

  public voltar() {
    this.consultarPropostaService.setRealizaPesquisa(true);
    this.router.navigate(['/consultar-proposta']);
  }

  private getValorPercentual(valorPercentual): number {
    if (valorPercentual && valorPercentual !== null && valorPercentual !== '') {
      return Number(valorPercentual.toString().replace('%', '').trim());
    } else {
      return Number(0);
    }
  }

  private zerarValoresDesconto() {
    console.log("Zerando valores de desconto...");
    this.formAcordo.controls['percentualDesconto'].setValue(0);
    this.formAcordo.controls['valorDiferencaDivida'].setValue(0);
    this.formAcordo.controls['valorAcordo'].setValue(Number(this.formAcordo.getRawValue().valorAtualizado));
  }

  private getValorJurosParcela(parcela: Parcela): number {
    let valorParcelaComJuros = Number(0);
    if (AppConstantes.FLAG_SIM === parcela.flagCobrancaJuroAtraso) {
      valorParcelaComJuros = parcela.valorParcela * 1 / 100;
    }
    return valorParcelaComJuros;
  }

  private getDataFormatada(data: any): string {
    let dataFormatada = '';
    if (data && data !== '') {
      dataFormatada = moment(data, "YYYY-MM-DD").format("DD/MM/YYYY")
    }
    return dataFormatada;
  }

  public getSubmitted() {
    return this._submitted;
  }

  public selecionarPagador(indexPagador) {

    this.formAcordo.controls['flagPagador'].setValue(indexPagador);
    console.log("Pagador selecionado no index: " + this.formAcordo.value['flagPagador']);
    if (this.acordo.devedores && this.acordo.devedores.length > 0) {
      for (var i = 0; i < this.devedores.length; i++) {
        if (this.formAcordo.value['flagPagador'] === i) {
          this.devedores[i].flagPagador = true;
        }
      }
    }
  }

  public editarDevedor(indexDevedor) {
    this.edicaoDevedor = true;

    this.limparDadosDevedor();
    this.indexEdicaoDevedor = indexDevedor;
    this.obterLogradouroPorCodigo(this.acordo.devedores[indexDevedor].endereco.codigoEndereco);


    console.log("Pagador selecionado no index: " + this.formAcordo.value['flagPagador']);

    if (this.acordo.devedores && this.acordo.devedores.length > 0) {
      const telefoneControl = <FormArray>this.formAcordo.controls['telefonesDevedor'];
      const emailControl = <FormArray>this.formAcordo.controls['emailsDevedor'];

      this.formAcordo.controls['nomeNovoDevedor'].setValue(this.acordo.devedores[indexDevedor].nome);
      this.formAcordo.controls['scoreDevedor'].setValue(this.acordo.devedores[indexDevedor].score);
      this.formAcordo.controls['negativadoNovoDevedor'].setValue(this.acordo.devedores[indexDevedor].flagNegativado);
      this.formAcordo.controls['congenereNovoDevedor'].setValue(this.acordo.devedores[indexDevedor].flagCongenere);
      this.formAcordo.controls['flagPagador'].setValue(this.acordo.devedores[indexDevedor].flagPagador);
      this.formAcordo.controls['numeroNovoDevedor'].setValue(this.acordo.devedores[indexDevedor].endereco.numero);
      this.formAcordo.controls['complementoNovoDevedor'].setValue(this.acordo.devedores[indexDevedor].endereco.complemento);
      this.formAcordo.controls['codigoCategoriaDevedor'].setValue(this.acordo.devedores[indexDevedor].codigoCategoriaDevedor);

      if (this.acordo.devedores[indexDevedor].tipoPessoa == TipoPessoaEnum.JURIDICA) {
        this.formAcordo.controls['tipoPessoa'].setValue(1);
        this.formAcordo.controls['cnpjNovoDevedor'].setValue(this.acordo.devedores[indexDevedor].cnpj);
        this.valorTipoPessoaRetorno = this.formAcordo.controls['tipoPessoa'].value;
      } else {
        this.formAcordo.controls['tipoPessoa'].setValue(0);
        this.formAcordo.controls['cpfNovoDevedor'].setValue(this.acordo.devedores[indexDevedor].cpf);
        this.valorTipoPessoaRetorno = this.formAcordo.controls['tipoPessoa'].value;
      }

      let dddTelefone;
      let numeroTelefone;
      let telefoneCompleto;
      let valorTipoLinhaTelefonica;

      for (let i = 0; i < this.acordo.devedores[indexDevedor].telefones.length; i++) {

        dddTelefone = this.acordo.devedores[indexDevedor].telefones[i].codigoDDDTelefone;
        numeroTelefone = this.acordo.devedores[indexDevedor].telefones[i].numeroTelefone;
        telefoneCompleto = String(dddTelefone) + String(numeroTelefone);
        telefoneCompleto = parseInt(telefoneCompleto);

        if (this.acordo.devedores[indexDevedor].telefones[i].tipoLinhaTelefonica == TipoLinhaTelefonicaEnum.FIXO) {
          valorTipoLinhaTelefonica = 0;
        } else if (this.acordo.devedores[indexDevedor].telefones[i].tipoLinhaTelefonica == TipoLinhaTelefonicaEnum.CELULAR) {
          valorTipoLinhaTelefonica = 1;
        }

        telefoneControl.push(this.formBuilder.group({ tipoTelefone: valorTipoLinhaTelefonica, telefone: telefoneCompleto }));
      }
      for (let i = 0; i < this.acordo.devedores[indexDevedor].emails.length; i++) {

        let emailNovoDevedor = this.acordo.devedores[indexDevedor].emails[i].endereco;
        emailControl.push(this.formBuilder.group({ emailNovoDevedor }));
      }
    }

  }

  private limparDadosDevedor() {

    this.formAcordo.controls['nomeNovoDevedor'].setValue(null);
    this.formAcordo.controls['cpfNovoDevedor'].setValue('');
    this.formAcordo.controls['cnpjNovoDevedor'].setValue('');
    this.formAcordo.controls['scoreDevedor'].setValue(null);
    this.formAcordo.controls['negativadoNovoDevedor'].setValue(null);
    this.formAcordo.controls['congenereNovoDevedor'].setValue(null);
    this.formAcordo.controls['cepNovoDevedor'].setValue(null);
    this.formAcordo.controls['tipoEnderecoNovoDevedor'].setValue(null);
    this.formAcordo.controls['enderecoNovoDevedor'].setValue(null);
    this.formAcordo.controls['numeroNovoDevedor'].setValue(null);
    this.formAcordo.controls['complementoNovoDevedor'].setValue(null);
    this.formAcordo.controls['bairroNovoDevedor'].setValue(null);
    this.formAcordo.controls['cidadeNovoDevedor'].setValue(null);
    this.formAcordo.controls['estadoNovoDevedor'].setValue(null);

    var telefonesArray = this.formAcordo.get('telefonesDevedor') as FormArray;
    while (telefonesArray.length !== 0) {
      telefonesArray.removeAt(0);
    }

    var emailsArray = this.formAcordo.get('emailsDevedor') as FormArray;
    while (emailsArray.length !== 0) {
      emailsArray.removeAt(0);
    }
  }

  carregarDadosDevedores() {
    console.log('serasa'+this.acordo.devedores[this.indexEdicaoDevedor].score);
    this.acordo.devedores[this.indexEdicaoDevedor].codigoCategoriaDevedor = this.formAcordo.controls['codigoCategoriaDevedor'].value;
    this.acordo.devedores[this.indexEdicaoDevedor].cpf = (this.formAcordo.value['cpfNovoDevedor'] != undefined) ?
      this.formAcordo.value['cpfNovoDevedor'].replace(/\./g, '').replace('-', '') : null;
    this.acordo.devedores[this.indexEdicaoDevedor].cnpj = (this.formAcordo.value['cnpjNovoDevedor'] != undefined) ?
      CnpjUtils.normalizar(this.formAcordo.value['cnpjNovoDevedor']) : null;
    this.acordo.devedores[this.indexEdicaoDevedor].flagNegativado = this.formAcordo.value['negativadoNovoDevedor'];
    this.acordo.devedores[this.indexEdicaoDevedor].flagCongenere = this.formAcordo.value['congenereNovoDevedor'];
    //this.acordo.devedores[this.indexEdicaoDevedor].flagPagador = null;

    //-- Telefones
    this.acordo.devedores[this.indexEdicaoDevedor].telefones = [];
    var telefonesArray = this.formAcordo.controls['telefonesDevedor'] as FormArray;
    this.acordo.devedores[this.indexEdicaoDevedor].strTelefoneGrid = telefonesArray.value[0].telefone.toString();


    let dddTelefoneGravacao;
    let numeroTelefoneGravacao;
    for (var i = 0; i < telefonesArray.length; i++) {

      this.acordo.devedores[this.indexEdicaoDevedor].telefones[i] = {};
      telefonesArray.value[i].telefone = telefonesArray.value[i].telefone.toString();

      if (telefonesArray.value[i].tipoTelefone == 0 && telefonesArray.value[i].telefone.length == 14) {
        dddTelefoneGravacao = telefonesArray.value[i].telefone.substring(1, 3);
        numeroTelefoneGravacao = telefonesArray.value[i].telefone.substring(4, 14).replace('-', '').trim();
        this.acordo.devedores[this.indexEdicaoDevedor].telefones[i].codigoDDDTelefone = parseInt(dddTelefoneGravacao);
        this.acordo.devedores[this.indexEdicaoDevedor].telefones[i].numeroTelefone = parseInt(numeroTelefoneGravacao);
      } else if (telefonesArray.value[i].tipoTelefone == 0 && telefonesArray.value[i].telefone.length == 10) {
        dddTelefoneGravacao = telefonesArray.value[i].telefone.substring(0, 2);
        numeroTelefoneGravacao = telefonesArray.value[i].telefone.substring(2, 10);
        this.acordo.devedores[this.indexEdicaoDevedor].telefones[i].codigoDDDTelefone = parseInt(dddTelefoneGravacao);
        this.acordo.devedores[this.indexEdicaoDevedor].telefones[i].numeroTelefone = parseInt(numeroTelefoneGravacao);
      } else if (telefonesArray.value[i].tipoTelefone == 1 && telefonesArray.value[i].telefone.length == 15) {
        dddTelefoneGravacao = telefonesArray.value[i].telefone.substring(1, 3);
        numeroTelefoneGravacao = telefonesArray.value[i].telefone.substring(4, 15).replace('-', '').trim();
        this.acordo.devedores[this.indexEdicaoDevedor].telefones[i].codigoDDDTelefone = parseInt(dddTelefoneGravacao);
        this.acordo.devedores[this.indexEdicaoDevedor].telefones[i].numeroTelefone = parseInt(numeroTelefoneGravacao);
      } else if (telefonesArray.value[i].tipoTelefone == 1 && telefonesArray.value[i].telefone.length == 11) {
        dddTelefoneGravacao = telefonesArray.value[i].telefone.substring(0, 2);
        numeroTelefoneGravacao = telefonesArray.value[i].telefone.substring(2, 11);
        this.acordo.devedores[this.indexEdicaoDevedor].telefones[i].codigoDDDTelefone = parseInt(dddTelefoneGravacao);
        this.acordo.devedores[this.indexEdicaoDevedor].telefones[i].numeroTelefone = parseInt(numeroTelefoneGravacao);
      }

      this.acordo.devedores[this.indexEdicaoDevedor].telefones[i] = {};
      this.acordo.devedores[this.indexEdicaoDevedor].telefones[i].codigoDDDTelefone = dddTelefoneGravacao;
      this.acordo.devedores[this.indexEdicaoDevedor].telefones[i].numeroTelefone = numeroTelefoneGravacao;

      if (telefonesArray.value[i].tipoTelefone == 0) {
        this.acordo.devedores[this.indexEdicaoDevedor].telefones[i].tipoLinhaTelefonica = TipoLinhaTelefonicaEnum.FIXO;
      }
      else if (telefonesArray.value[i].tipoTelefone == 1) {
        this.acordo.devedores[this.indexEdicaoDevedor].telefones[i].tipoLinhaTelefonica = TipoLinhaTelefonicaEnum.CELULAR;
      }
    }

    this.acordo.devedores[this.indexEdicaoDevedor].emails = [];
    var emailsArray = this.formAcordo.get('emailsDevedor') as FormArray;
    for (var i = 0; i < emailsArray.length; i++) {

      this.acordo.devedores[this.indexEdicaoDevedor].emails[i] = {};
      this.acordo.devedores[this.indexEdicaoDevedor].emails[i].endereco = emailsArray.value[i].emailNovoDevedor.toString();
    }

    if ( this.formAcordo.value['cepNovoDevedor'] && this.acordo.devedores[this.indexEdicaoDevedor].endereco.cep.replace("-", "") != this.formAcordo.value['cepNovoDevedor'] ) {
      this.acordo.devedores[this.indexEdicaoDevedor].endereco.codigoEndereco = this.formAcordo.value['codigoEndereco'];
      this.acordo.devedores[this.indexEdicaoDevedor].endereco.cep = this.formAcordo.value['cepNovoDevedor'];
      this.acordo.devedores[this.indexEdicaoDevedor].endereco.tipoEndereco = this.formAcordo.value['tipoEnderecoNovoDevedor'];
      this.acordo.devedores[this.indexEdicaoDevedor].endereco.logradouro = this.formAcordo.value['enderecoNovoDevedor'];
      this.acordo.devedores[this.indexEdicaoDevedor].endereco.numero = this.formAcordo.value['numeroNovoDevedor'];
      this.acordo.devedores[this.indexEdicaoDevedor].endereco.complemento = this.formAcordo.value['complementoNovoDevedor'];
      this.acordo.devedores[this.indexEdicaoDevedor].endereco.bairro = this.formAcordo.value['bairroNovoDevedor'];
      this.acordo.devedores[this.indexEdicaoDevedor].endereco.cidade = this.formAcordo.value['cidadeNovoDevedor'];
      this.acordo.devedores[this.indexEdicaoDevedor].endereco.estado = this.formAcordo.value['estadoNovoDevedor'];
    } else {
      this.acordo.devedores[this.indexEdicaoDevedor].endereco.cep = this.formAcordo.value['cepNovoDevedor'];
      this.acordo.devedores[this.indexEdicaoDevedor].endereco.logradouro = this.formAcordo.value['enderecoNovoDevedor'];
      this.acordo.devedores[this.indexEdicaoDevedor].endereco.numero = this.formAcordo.value['numeroNovoDevedor'];
      this.acordo.devedores[this.indexEdicaoDevedor].endereco.complemento = this.formAcordo.value['complementoNovoDevedor'];
      this.acordo.devedores[this.indexEdicaoDevedor].endereco.bairro = this.formAcordo.value['bairroNovoDevedor'];
      this.acordo.devedores[this.indexEdicaoDevedor].endereco.cidade = this.formAcordo.value['cidadeNovoDevedor'];
      this.acordo.devedores[this.indexEdicaoDevedor].endereco.estado = this.formAcordo.value['estadoNovoDevedor'];
    }
    if (this.acordo.devedores[this.indexEdicaoDevedor].endereco.complemento != undefined) {
      this.acordo.devedores[this.indexEdicaoDevedor].endereco.complemento = this.acordo.devedores[this.indexEdicaoDevedor].endereco.complemento.trim().substring(0,9);
    }
    if (this.acordo.devedores[this.indexEdicaoDevedor].endereco.bairro != undefined) {
      this.acordo.devedores[this.indexEdicaoDevedor].endereco.bairro = this.acordo.devedores[this.indexEdicaoDevedor].endereco.bairro.trim().substring(0,39);
    }
  }

  public carregarDadosLinhaDotempo() {
    this.historicoService.obterLinhaTempoAcordo(this.idAcordo).subscribe(data => {
      this.situacaoDoAcordo = data;

      for (let i = 0; i < this.situacaoDoAcordo.length; i++) {
        this.situacaoDoAcordo[i].data = moment(this.situacaoDoAcordo[i].data, "DD/MM/YYYY");
        this.situacaoDoAcordo[i].data = this.situacaoDoAcordo[i].data.format("DD/MM/YYYY");
        this.flagHabilitarJustificativa[i] = false;

        if (this.situacaoDoAcordo.length == 1 && this.situacaoDoAcordo[0].codigoStatus == 4) {
          this.flagHabilitarBotaoAprovacaoReprovacao = true;
        } else {
          this.flagHabilitarBotaoAprovacaoReprovacao = false;
        }

        if (this.situacaoDoAcordo[i].codigoStatus == 5 || this.situacaoDoAcordo[i].codigoStatus == 3 || this.situacaoDoAcordo[i].codigoStatus == 6) {
          this.flagBotaoCancelarProposta = false;
        } else {
          this.flagBotaoCancelarProposta = true;
        }
      }
    });
  }

  public reprovarProposta(ModalReprovar, ModalCancelarPropostaLoading) {
    if (this.formAcordo.controls['textoJustificativaCancelamento'].value == "") {
      this.appComponent.createAlert('Por favor. Informe a justificativa.', 'alert');
    } else {
      this.reprovacaoProposta.codigoAcordo = this.idAcordo;
      this.reprovacaoProposta.textoJustificativaCancelamento = this.formAcordo.value['textoJustificativaCancelamento'];

      ModalReprovar.close();
      ModalCancelarPropostaLoading.open();

      this.propostaService.cancelarProposta(this.reprovacaoProposta).subscribe(response => {
        this.carregarDadosLinhaDotempo();
        ModalCancelarPropostaLoading.close();
        this.appComponent.createAlert('A proposta ' + this.acordo.codigoAcordoSistema + ' foi reprovada com sucesso.', 'success');

        this.recarregar();
      }, message => {
        ModalCancelarPropostaLoading.close();
        this.appComponent.createAlert(message.error.message, 'error');
      });
    }
  }

  public aprovarProposta(ModalAprovar, ModalAprovarPropostaLoading) {
    if (this.formAcordo.controls['textoJustificativaAprovacao'].value == "") {
      this.appComponent.createAlert('Por favor. Informe a justificativa.', 'alert');
    } else {
      this.aprovacaoProposta.codigoAcordo = this.idAcordo;
      this.aprovacaoProposta.textoJustificativaAprovacao = this.formAcordo.value['textoJustificativaAprovacao'];

      ModalAprovar.close();
      ModalAprovarPropostaLoading.open();

      this.propostaService.aprovarProposta(this.aprovacaoProposta).subscribe(response => {
        this.carregarDadosLinhaDotempo();
        ModalAprovarPropostaLoading.close();
        this.appComponent.createAlert('A proposta ' + this.acordo.codigoAcordoSistema + ' foi aprovada com sucesso.', 'success');

        this.recarregar();
      }, message => {
        ModalAprovarPropostaLoading.close();
        console.log(message.error)
        this.appComponent.createAlert(message.error.message, 'error');
      });

    }
  }

  public verificaCancelamentoAcordo(ModalCancelamento, ModalCancelarAcordo, ModalPadrao, $event){
    let existeparcelatransacional = false;
    for (let i = 0; i < this.acordo.parcelaLista.parcelas.length; i++) {
      if (this.acordo.parcelaLista.parcelas[i].tipoSituacaoParcelaAcordo.nomeTipoSituacaoParcelaAcordo == 'AGUARDANDO BAIXA') {
        existeparcelatransacional = true;
      }
    }

    if (existeparcelatransacional) {
      ModalCancelamento.open($event);
    } else {
      ModalPadrao.open($event);
    };
    //this.cancelarAcordo(ModalPadrao, ModalCancelarAcordo);
  }

  public cancelarAcordo(ModalPadrao, ModalCancelarAcordo) {

    if (this.formAcordo.controls['textoJustificativaCancelamento'].value == "") {
      this.appComponent.createAlert('Por favor. Informe a justificativa.', 'alert');
    } else {
      this.sapCancelamento.textoJustificativaCancelamento = this.formAcordo.value['textoJustificativaCancelamento'];
      this.sapCancelamento.codigoAcordo = this.idAcordo;

      ModalPadrao.close();
      ModalCancelarAcordo.open();
      this.sapService.cancelarContratoSAP(this.sapCancelamento).subscribe(retorno => {
        this.carregarDadosLinhaDotempo();
        ModalCancelarAcordo.close();
        this.appComponent.createAlert('O acordo ' + this.acordo.codigoAcordoSistema + ' foi cancelado com sucesso.', 'success');

        this.recarregar();
      }, message => {
        ModalCancelarAcordo.close();
        const mensagemErro = message.status === 500
          ? 'Ocorreu um erro. Acione os administradores do sistema.'
          : (message.error && message.error.message) || 'Ocorreu um erro ao cancelar o Acordo. Tente novamente mais tarde.';
        this.appComponent.createAlert(mensagemErro, 'error');
      });

    }

  }

  atualizarDadosDevedor(ModalDevedor) {
    this.carregarDadosDevedores();
    this.showLoading();
    this.devedoresService.atualizarDevedor(this.acordo.devedores[this.indexEdicaoDevedor]).subscribe(response => {
      ModalDevedor.close();
      this.hideLoading();
      this.appComponent.createAlert('Dados do terceiro atualizado com sucesso.', 'success');

      this.recarregar();
    }, error => {
      this.hideLoading();
      this.appComponent.createAlert('Não foi possível atualizar os dados do terceiro.', 'error');
      console.log('Não foi possível atualizar os dados do terceiro. ' + error);
    });
  }

  public obterLogradouroPorCodigo(codigoLocalidade) {
    this.guiaPostalService.obterLogradouroPorCodigo(codigoLocalidade).subscribe(retornoLogradouro => {
      this.formAcordo.controls['tipoEnderecoNovoDevedor'].setValue(retornoLogradouro.logradouro.tipoLogradouro.nomeTipoLogradouro);
      this.formAcordo.controls['enderecoNovoDevedor'].setValue(retornoLogradouro.logradouro.nomeLogradouro);
      this.formAcordo.controls['bairroNovoDevedor'].setValue(retornoLogradouro.logradouro.bairro.nomeBairro);
      this.formAcordo.controls['cidadeNovoDevedor'].setValue(retornoLogradouro.logradouro.localidade.nomeLocalidade);
      this.formAcordo.controls['estadoNovoDevedor'].setValue(retornoLogradouro.logradouro.localidade.estado.siglaEstado);
      this.formatarNumeroCepLogradouro(retornoLogradouro.logradouro.numeroCepLogradouro);
      this.formatarNumeroCepComplementoLogradouro(retornoLogradouro.logradouro.numeroCepComplementoLogradouro);
      this.formAcordo.controls['cepNovoDevedor'].setValue(this.numeroCepLogradouro + this.numeroCepComplementoLogradouro);
    }, error => {
      this.appComponent.createAlert('Não foi possível obter o endereço pelo CEP.', 'error');
      console.log('Não foi possível obter o endereço pelo CEP: ' + error);
    });
  }

  public obterDadosParcela(indexParcela) {

    if (this.formAcordo.get('radioEntrada').value == '1')
      indexParcela++;

    console.info("indexParcela - " + indexParcela);

    this.indexAtualizacaoParcela = indexParcela;
    let dadosParcela = this.acordo.parcelaLista.parcelas;
    this.formAcordo.controls['novaDataVencimento'].setValue(moment(dadosParcela[indexParcela].dataVencimentoParcela, "YYYY-MM-DD").format("DD/MM/YYYY"));

    if (dadosParcela[indexParcela].flagCobrancaJuroAtraso == AppConstantes.FLAG_SIM) {
      this.formAcordo.controls['checkboxComJuros'].setValue(true);
    } else {
      this.formAcordo.controls['checkboxComJuros'].setValue(false);
    }

    //Regra do SAP:
    //Não é possível realizar a prorrogação com a data solicitada. Somente será possível realizar uma prorrogação até  30  dias após o vencimento.
    //Bloquear o calendário considerando os 30 dias corridos após o vencimento.
    var minDate = new Date(dadosParcela[indexParcela].dataVencimentoParcela);
    minDate.setDate(minDate.getDate() + 91);
    this.dataMinimaSelecao = moment(minDate, "DD/MM/YYYY").format("DD/MM/YYYY");


  }

  public atualizarDadosParcela(ModalParcela, ModalAtualizarParcelaLoading) {

    this.sapAtualizarParcela.codigoAcordo = this.acordo.codigoAcordo;
    this.sapAtualizarParcela.flagCobrarJuros = this.formAcordo.value['checkboxComJuros'];
    this.sapAtualizarParcela.numeroParcela = this.acordo.parcelaLista.parcelas[this.indexAtualizacaoParcela].numeroParcela;
    this.sapAtualizarParcela.novaDataVencimento = moment(this.formAcordo.value['novaDataVencimento'], "DD/MM/YYYY").format("YYYY-MM-DD");


    ModalParcela.close();
    ModalAtualizarParcelaLoading.open();
    this.sapService.alterarDataVencimentoParcelaSAP(this.sapAtualizarParcela).subscribe(data => {
      ModalAtualizarParcelaLoading.close();
      this.appComponent.createAlert('Dados do terceiro atualizado com sucesso.', 'success');
      this.recarregar();
    }, message => {
      ModalAtualizarParcelaLoading.close();
      this.appComponent.createAlert(message.error.message, 'error');
      console.log(message.error.message);

    });
  }

  public simularDadosParcela(ModalParcela, ModalSimularParcelaLoading) {

    this.sapAtualizarParcela.codigoAcordo = this.acordo.codigoAcordo;
    this.sapAtualizarParcela.flagCobrarJuros = this.formAcordo.value['checkboxComJuros'];
    this.sapAtualizarParcela.numeroParcela = this.acordo.parcelaLista.parcelas[this.indexAtualizacaoParcela].numeroParcela;
    this.sapAtualizarParcela.novaDataVencimento = moment(this.formAcordo.value['novaDataVencimento'], "DD/MM/YYYY").format("YYYY-MM-DD");

    //ModalParcela.close();
    ModalSimularParcelaLoading.open();

    this.sapService.simularAlteracaoDataVencimentoParcelaSAP(this.sapAtualizarParcela).subscribe(data => {
      this.appComponent.createAlert('Simulação efetuada com sucesso.', 'success');
      this.valorSimulacao = data.valorParcela;
      this.formAcordo.controls['valorSimulacao'].setValue(this.valorSimulacao);
      ModalSimularParcelaLoading.close();
    }, message => {
      ModalSimularParcelaLoading.close();
      this.appComponent.createAlert(message.error.message, 'error');
      console.log(message.error.message);
    });

  }

  public abrirSegundaViaBoleto(ModalSegundaViaBoleto, codigoParcela) {
    this.formAcordo.controls['codigoParcela2Via'].setValue(codigoParcela);

    var emailDevedorPrincipal = null;
    for (let i = 0; i < this.acordo.devedores.length; i++) {
      if (this.acordo.devedores[i].flagPagador) {
        emailDevedorPrincipal = this.acordo.devedores[i].emails[0].endereco;
      }
    }

    this.formAcordo.controls['enderecoEmail2Via'].setValue(emailDevedorPrincipal);
    ModalSegundaViaBoleto.open();
  }

  public gerarSegundaViaBoleto(ModalSegundaViaBoleto, ModalSegundaViaBoletoLoading) {

    if (this.formAcordo.controls['enderecoEmail2Via'].value == "") {
      this.appComponent.createAlert('Por favor. Informe um Email para envio do Boleto.', 'alert');
      return;
    }

    ModalSegundaViaBoleto.close();
    ModalSegundaViaBoletoLoading.open();

    var params: BoletoService.GerarSegundaViaBoletoParams = {
      codigoAcordo: this.acordo.codigoAcordo,
      codigoParcela: this.formAcordo.controls['codigoParcela2Via'].value,
      enderecoEmail: this.formAcordo.controls['enderecoEmail2Via'].value
    };

    this.boletoService.gerarSegundaViaBoleto(params).subscribe(data => {
      ModalSegundaViaBoletoLoading.close();
      console.log(data.message);
      this.appComponent.createAlert('Segunda via do Boleto enviada com sucesso.', 'success');
    }, message => {
      ModalSegundaViaBoletoLoading.close();
      this.appComponent.createAlert('Não foi possível gerar a Segunda Via do Boleto.', 'error');
    });
  }

  public pesquisarCEP() {

    this.formAcordo.controls['codigoEndereco'].setValue(null);
    var cep = this.formAcordo.value['cepNovoDevedor'];

    console.log("consultando o cep : " + cep);

    if (cep.length === 9) {

      var cepInicial = cep.substring(0, 5);
      var cepFinal = cep.substring(6, 9);

      var params: GuiaPostalService.ObterLogradourosParams = { numeroCepLogradouro: cepInicial, numeroCepComplementoLogradouro: cepFinal };

      this.guiaPostalService.obterLogradouros(params).subscribe(response => {

        this.formAcordo.controls['codigoEndereco'].setValue(response.logradouros[0].codigoLogradouro);
        this.formAcordo.controls['tipoEnderecoNovoDevedor'].setValue(
          response.logradouros[0].tipoLogradouro.nomeTipoLogradouro);
        this.formAcordo.controls['enderecoNovoDevedor'].setValue(
          response.logradouros[0].nomeLogradouro);
        this.formAcordo.controls['bairroNovoDevedor'].setValue(
          response.logradouros[0].bairro.nomeBairro);
        this.formAcordo.controls['cidadeNovoDevedor'].setValue(
          response.logradouros[0].localidade.nomeLocalidade);
        this.formAcordo.controls['estadoNovoDevedor'].setValue(
          response.logradouros[0].localidade.estado.siglaEstado);

        this.formAcordo.controls['numeroNovoDevedor'].setValue(null);
        this.formAcordo.controls['complementoNovoDevedor'].setValue(null);
      }, error => {
        this.appComponent.createAlert('Não foi possível obter o endereço pelo CEP.', 'error');
        console.log('Não foi possível obter o endereço pelo CEP: ' + error);
      });
    }
  }

  private validarFormularioNovoDevedor(): boolean {

    let isCampoFocus = false;
    var isValido = true;


    if (!this.formAcordo.value['nomeNovoDevedor']) {
      isValido = false;
      this.formAcordo.controls['nomeNovoDevedor'].setErrors({ 'incorrect': true });
      if (!isCampoFocus) {
        document.getElementById('nomeNovoDevedor').focus(); isCampoFocus = true
      };
    }

    if (!this.formAcordo.value['scoreDevedor']) {
      isValido = false;
      this.formAcordo.controls['scoreDevedor'].setErrors({ 'incorrect': true });
      if (!isCampoFocus) {
        document.getElementById('scoreDevedor').focus(); isCampoFocus = true
      };
    }

    if (this.formAcordo.value['telefonesDevedor'].length === 0) {
      isValido = false;
      this.formAcordo.controls['telefonesDevedor'].setErrors({ 'incorrect': true });
    } else {

      var telefonesArray = this.formAcordo.get('telefonesDevedor') as FormArray;
      for (var i = 0; i < telefonesArray.length; i++) {

        if (telefonesArray.value[i].telefone.length < 14) {
          isValido = false;
          this.formAcordo.controls['telefonesDevedor'].setErrors({ 'incorrect': true });
          break;
        }
      }
    }

    if (this.formAcordo.value['emailsDevedor'].length === 0) {
      isValido = false;
      this.formAcordo.controls['emailsDevedor'].setErrors({ 'incorrect': true });
    } else {

      var emailsArray = this.formAcordo.get('emailsDevedor') as FormArray;
      for (var i = 0; i < emailsArray.length; i++) {

        if (emailsArray.value[i].status === 'INVALID') {
          isValido = false;
          this.formAcordo.controls['emailsDevedor'].setErrors({ 'incorrect': true });
          break;
        }
      }
    }

    if (!this.formAcordo.value['cepNovoDevedor'] || this.formAcordo.value['cepNovoDevedor'].length < 9) {
      isValido = false;
      this.formAcordo.controls['cepNovoDevedor'].setErrors({ 'incorrect': true });
      if (!isCampoFocus) {
        document.getElementById('cepNovoDevedor').focus(); isCampoFocus = true
      };
    }

    if (!this.formAcordo.value['cepNovoDevedor'] || this.formAcordo.value['cepNovoDevedor'].length < 9) {
      isValido = false;
      this.formAcordo.controls['cepNovoDevedor'].setErrors({ 'incorrect': true });
      if (!isCampoFocus) {
        document.getElementById('cepNovoDevedor').focus(); isCampoFocus = true
      };
    }

    if (!this.formAcordo.value['tipoEnderecoNovoDevedor']) {
      isValido = false;
      this.formAcordo.controls['tipoEnderecoNovoDevedor'].setErrors({ 'incorrect': true });
      if (!isCampoFocus) {
        document.getElementById('tipoEnderecoNovoDevedor').focus(); isCampoFocus = true
      };
    }

    if (!this.formAcordo.value['enderecoNovoDevedor']) {
      isValido = false;
      this.formAcordo.controls['enderecoNovoDevedor'].setErrors({ 'incorrect': true });
      if (!isCampoFocus) {
        document.getElementById('enderecoNovoDevedor').focus(); isCampoFocus = true
      };
    }

    if (!this.formAcordo.value['numeroNovoDevedor']) {
      isValido = false;
      this.formAcordo.controls['numeroNovoDevedor'].setErrors({ 'incorrect': true });
      if (!isCampoFocus) {
        document.getElementById('numeroNovoDevedor').focus(); isCampoFocus = true
      };
    }

    if (!this.formAcordo.value['bairroNovoDevedor']) {
      isValido = false;
      this.formAcordo.controls['bairroNovoDevedor'].setErrors({ 'incorrect': true });
      if (!isCampoFocus) {
        document.getElementById('bairroNovoDevedor').focus(); isCampoFocus = true
      };
    }

    if (!this.formAcordo.value['cidadeNovoDevedor']) {
      isValido = false;
      this.formAcordo.controls['cidadeNovoDevedor'].setErrors({ 'incorrect': true });
      if (!isCampoFocus) {
        document.getElementById('cidadeNovoDevedor').focus(); isCampoFocus = true
      };
    }

    if (!this.formAcordo.value['estadoNovoDevedor']) {
      isValido = false;
      this.formAcordo.controls['estadoNovoDevedor'].setErrors({ 'incorrect': true });
      if (!isCampoFocus) {
        document.getElementById('estadoNovoDevedor').focus(); isCampoFocus = true
      };
    }
    return isValido;
  }

  private  recarregar() : void {
    this.showLoading();


    if (this.idAcordo && Number(this.idAcordo) > 0) {

      this.acordoService.obterAcordoPorCodigo(this.idAcordo).subscribe(result => {
        this.acordo = result;
        this.criarFormulario(this.acordo);

        //carregar as combobox
        this.carregarTiposRecebimento();
        this.carregarTiposOrigem();
        this.carregarProcedenciasAcordo();
        this.carregarFormasPagamento();
        this.carregarCategoriaDevedores();
        this.carregarHistoricoErrosSAP();
        this.carregarDinamicas();
        this.carregarCongeneres();
        this.carregarAcordo(this.acordo);
        this.hideLoading();

        let dddTelefoneFixo;
        let numeroTelefoneFixo;
        let dddTelefoneCelular;
        let numeroTelefoneCelular;

        this.carregarDadosLinhaDotempo();

        for(let i = 0; i < this.acordo.devedores.length; i++) {

          for(let index = 0; index < this.acordo.devedores[i].telefones.length; index++) {

              if(this.acordo.devedores[i].telefones[index].tipoLinhaTelefonica == TipoLinhaTelefonicaEnum.FIXO) {
                dddTelefoneFixo = this.acordo.devedores[i].telefones[index].codigoDDDTelefone;
                numeroTelefoneFixo = this.acordo.devedores[i].telefones[index].numeroTelefone.toString();
                this.acordo.devedores[i].strTelefoneGrid = dddTelefoneFixo + numeroTelefoneFixo;
                this.acordo.devedores[i].strTelefoneGrid = this.acordo.devedores[i].strTelefoneGrid.replace(/^(\d\d)(\d)/g,"($1) $2");
                this.acordo.devedores[i].strTelefoneGrid = this.acordo.devedores[i].strTelefoneGrid.replace(/(\d{4})(\d)/,"$1-$2");

              } else if (this.acordo.devedores[i].telefones[index].tipoLinhaTelefonica == TipoLinhaTelefonicaEnum.CELULAR) {

                dddTelefoneCelular = this.acordo.devedores[i].telefones[index].codigoDDDTelefone;
                numeroTelefoneCelular = this.acordo.devedores[i].telefones[index].numeroTelefone.toString();
                this.acordo.devedores[i].strTelefoneGrid = dddTelefoneCelular + numeroTelefoneCelular;
                this.acordo.devedores[i].strTelefoneGrid = this.acordo.devedores[i].strTelefoneGrid.replace(/^(\d\d)(\d)/g,"($1) $2");
                this.acordo.devedores[i].strTelefoneGrid = this.acordo.devedores[i].strTelefoneGrid.replace(/(\d{5})(\d)/,"$1-$2");
              }
          }
        }

      }, error => {
        const theError: string = error.error.mensagens[2].mensagem;
        this.appComponent.createAlert(theError, 'error');
        console.log('Erro ao visualizar detalhes da proposta!' + error);
        this.hideLoading();
      });
    } else {
      this.hideLoading();
    }
  }

  public atualizarStatusSAP(ModalAtualizaStatusSAP, ModalAtualizarParcelaLoading) {
    ModalAtualizaStatusSAP.close();
    ModalAtualizarParcelaLoading.open();

    const param: Parcela = {
      codigoParcela: this.parcelaAtualizar.codigoParcela
    };

    this.parcelaService.atualizarStatusSAPParcela(param).subscribe(data => {
      ModalAtualizarParcelaLoading.close();
      this.appComponent.createAlert('Status da Parcela atualizado com sucesso!.', 'success');
      this.recarregar();
    }, message => {
      ModalAtualizarParcelaLoading.close();
      this.appComponent.createAlert('Ocorreu um erro ao atualizar o Status da Parcela', 'error');
    });
    console.log('Teste' + this.parcelaService.atualizarStatusSAPParcela(param));
    console.log('Teste1' + this.parcelaAtualizar.codigoParcela);
  }
  
//Estorno da pacela INICIO
public realizarEstornoSAP(ModalEstornoSAP, ModalAtualizarParcelaLoading) {
  this.idAcordo = this.route.snapshot.params['idAcordo'];

if (this.justificativaEstorno.trim() === "") {
  this.appComponent.createAlert('Por favor. Informe a justificativa.', 'alert');
} else {
  ModalEstornoSAP.close();
  ModalAtualizarParcelaLoading.open();

  const param: Parcela = {
    codigoParcela: this.parcelaAtualizar.codigoParcela,
    dataVencimento: this.parcelaAtualizar.dataVencimentoParcela,
    codigoAcordo: this.idAcordo,
    textoJustificativa: this.justificativaEstorno // Usando directly this.justificativaEstorno
  };

  this.parcelaService.realizarEstornoSAPParcela(param).subscribe(data => {
    ModalAtualizarParcelaLoading.close();
    this.appComponent.createAlert('Estorno da Parcela realizado com sucesso!.', 'success');
    this.recarregar();
  }, message => {
    ModalAtualizarParcelaLoading.close();
    this.appComponent.createAlert('Ocorreu um erro ao tentar efetuar o estorno da parcela', 'error');
  });

  console.log('Teste Estorno' + this.parcelaService.realizarEstornoSAPParcela(param));
  console.log('Estorno codigoParcela: ' + this.parcelaAtualizar.codigoParcela);
  console.log('Estorn acordo: ' + this.idAcordo);
  console.log('Estorn dataVencimentoParcela: ' + this.parcelaAtualizar.dataVencimentoParcela);
}
}
//Estorno da parcela FIM

/*
  public atualizarDataAntares(ModalAtualiza, ModalAtualizarParcelaLoading) {
    ModalAtualiza.close();
    ModalAtualizarParcelaLoading.open();

    const param: Parcela = {
      codigoParcela: this.parcelaAtualizar.codigoParcela,
      dataEnvioAntares: this.dataEnvioAntares
    };

    this.parcelaService.atualizarStatusSAPParcela(param).subscribe(data => {
      ModalAtualizarParcelaLoading.close();
      this.appComponent.createAlert('Data de Envio Antares atualizado com sucesso!.', 'success');
      this.recarregar();
    }, message => {
      ModalAtualizarParcelaLoading.close();
      this.appComponent.createAlert('Ocorreu um erro ao atualizar o Data do Envio', 'error');
    });
  }
*/
  public alterarDadosAcordo(ModalSimularParcelaLoading) {

    ModalSimularParcelaLoading.open();

    this.acordo.procedencia.codigoProcedencia = this.formAcordo.value['codigoProcedencia'];
    this.acordo.tipoRecebimento.codigoTipoRecebimento = this.formAcordo.value['codigoTipoRecebimento'];
    this.acordo.tipoOrigemAcordo.codigoTipoOrigem = this.formAcordo.value['codigoTipoOrigem'];

    for (let key in this.listaDinamicas) {
      if (this.listaDinamicas[key].descricaoDinamica == this.formAcordo.value['dinamica']) {
        this.acordo.dinamica = this.listaDinamicas[key].idDinamica;
      }
    }

    this.acordo.devedores = [];
    if (this.congenereSelecionado) {
      this.acordo.devedores.push({
        nome: this.congenereSelecionado
      });
    }

    this.acordoService.alterarAcordo(this.acordo).subscribe((data: any) => {
      location.reload();
    }, error => {
      ModalSimularParcelaLoading.close();
      this.appComponent.createAlert('Ocorreu um erro ao alterar o Acordo. Tente novamente mais tarde.', 'error');
      console.log('Erro ao alterar o acordo!' + error);
    });
  }

  public getCongenere() {

    return (keyword: any): Observable<any> => {
      const listaFiltrada = this.cadastroCongeneres.filter(function(congenere) {
         return congenere.descricao.toUpperCase().indexOf(keyword.toUpperCase()) !== -1;
      });

      const listaNomes =[];
      listaFiltrada.forEach(function(congenere){
         listaNomes.push(congenere.descricao);
      });

      return of(listaNomes);
    };
  }

  setCongenere($event) {
    this.congenereSelecionado = $event;

    const congenereFiltrada = this.cadastroCongeneres.filter(function(congenere) {
       return congenere.descricao.toUpperCase().indexOf($event.toUpperCase()) !== -1;
    });

    this.devedores.forEach(function(devedor){
       devedor.congenere = congenereFiltrada[0];
       this.formAcordo.controls['congenere'].setValue(congenereFiltrada[0]);
    });
  }

  public autoCompleteBuscaEscritorio() {
    return (keyword: any): Observable<any> => {
      this.nomeEscritorioFiltro = [];

      var parametros: EscritoriosService.ObterEscritoriosParams = {
        nomeEscritorio: this.formAcordo.controls['escritorio'].value,
        codigoRamoSinistro: this.appComponent.codigoRamo
      };

      this.escritorioService.obterEscritorios(parametros).subscribe(data => {
        this.listaEscritoriosFiltro = data;
        for (let key in data) {
          this.nomeEscritorioFiltro.push(data[key].nomeEscritorio);
        }
      });
      return of(this.nomeEscritorioFiltro);
    };
  }

  public autoCompleteBuscaEscritorioSelected($event) {
    this.selected = $event;

    for (let key in this.listaEscritoriosFiltro) {
      if (this.listaEscritoriosFiltro[key].nomeEscritorio == this.selected) {
        this.formAcordo.controls['codigoEscritorio'].setValue(this.listaEscritoriosFiltro[key].codigoEscritorio);
      }
    }
  }

  private carregarCadastroCongeneres(): void {
    this.congenereService.obterCadastroCongeneres().subscribe(result => {
      this.cadastroCongeneres = result;
    });
  }

  public reprocessarBoleto() {
    this.reprocessarBoletoBatch.codigoAcordo = this.idAcordo;
    this.propostaService.reprocessarBoletoAcordo(this.reprocessarBoletoBatch).subscribe(response => {
    this.appComponent.createAlert('OS BOLETOS SERÃO ENVIADOS PARA O E-MAIL CADASTRADO EM ATE 24 HORAS DO ACORDO ' + this.acordo.codigoAcordoSistema , 'success');
    this.recarregar();
    }, message => {
      this.appComponent.createAlert(message.error.message, 'error');
    });
  }

}